export class XpeditionsUserListRequest {
  search: string;
  dateB: string;
  dateE: string;
  xpeditionId: number;
  lang: string;
  limit: number;
  offset: number;
  sortProp: string;
  sortDir: string;
}
